(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/register-new/register-new.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/register-new/register-new.js');
"use strict";


const {
  UPDATE_REGISTER_INFORMATION
} = svs.ticket_partner.digitalTickets.actions;
const {
  useContext
} = React;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  CompanyNameInput,
  OrgNrInput,
  PhoneNrInput,
  ContactInput,
  EmailInput,
  CellPhoneNrInput
} = svs.ticket_partner.sharedComponents.input;
const {
  CONTACT_PERSON
} = svs.ticket_partner.sharedComponents.input.constants.names;
const {
  HEADER_COMPANY,
  HEADER_CONTACT_PERSON
} = svs.ticket_partner.digitalTickets.digitalTicketsForm.registerNew.constants.TEXTS;
const RegisterNew = () => {
  const {
    state,
    dispatch
  } = useContext(svs.ticket_partner.DigitalTicketsContext);
  const handleOnChange = _ref => {
    let {
      target
    } = _ref;
    dispatch({
      type: UPDATE_REGISTER_INFORMATION,
      payload: {
        field: target.id,
        value: target.value
      }
    });
  };
  return React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(GridRow, null, React.createElement("h2", null, HEADER_COMPANY)), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(CompanyNameInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(OrgNrInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(PhoneNrInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  }))), React.createElement(GridRow, null, React.createElement("h2", null, HEADER_CONTACT_PERSON)), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(ContactInput, {
    handleChange: handleOnChange,
    name: CONTACT_PERSON,
    state: state.registerNew,
    stateField: CONTACT_PERSON
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(EmailInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(CellPhoneNrInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  }))));
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.registerNew.RegisterNew = RegisterNew;

 })(window);